import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
var updateBrandsSubscriptions = mutatorAction('updateBrandsSubscriptions', function updateBrandsSubscriptions(response) {
    var brandsSubscriptionsStore = getStore();
    brandsSubscriptionsStore.subscriptions = response.subscriptions;
    brandsSubscriptionsStore.unsubscribedSubscriptions = response.unsubscribedSubscriptions;
});
export default updateBrandsSubscriptions;
//# sourceMappingURL=updateBrandsSubscriptions.js.map